/* eslint-disable sonarjs/deprecation -- Intentional legacy compatibility shim */
import { alpha } from "@mui/material";
import {
  palette,
  predefinedColors as tokenPredefinedColors,
  runtimePrimaryColors,
} from "theme/tokens/colors";

const runtimeEnv = typeof window !== "undefined" ? window._env_ : undefined;
const APP_ENV = runtimeEnv?.NODE_ENV
  ? runtimeEnv?.NODE_ENV
  : runtimeEnv?.STORYBOOK_APP_ENV;

/** @deprecated Use `palette.extended.primaryProd` from `theme/tokens/colors` */
export const PRIMARY_COLOR_PROD = runtimePrimaryColors.prod;

let primaryColor: string;
if (APP_ENV === "production") {
  primaryColor = runtimePrimaryColors.prod;
} else if (APP_ENV === "develop") {
  primaryColor = runtimePrimaryColors.develop;
} else {
  primaryColor = runtimePrimaryColors.staging;
}
export { primaryColor };

/** @deprecated Use `alpha(primaryColor, 0.7)` with the environment-selected `primaryColor`, not the fixed `palette.brand.primary.main` */
export const PrimaryFaded = alpha(primaryColor, 0.7);

/** @deprecated Use `palette.brand.secondary.main` from `theme/tokens/colors` */
export const secondaryColor = palette.brand.secondary.main;

/** @deprecated Use `palette.extended.cancel` from `theme/tokens/colors` */
export const cancelColor = palette.extended.cancel;

/** @deprecated Use `palette.extended.default` from `theme/tokens/colors` */
export const defaultColor = palette.extended.default;

/** @deprecated Use `palette.background.default` from `theme/tokens/colors` */
export const defaultBackground = palette.background.default;

/** @deprecated Use `palette.semantic.success.main` from `theme/tokens/colors` */
export const successColor = palette.semantic.success.main;

/** @deprecated Use `palette.semantic.warning.main` from `theme/tokens/colors` */
export const warningColor = palette.semantic.warning.main;

/** @deprecated Use `palette.extended.darkSeaGreen` from `theme/tokens/colors` */
export const darkSeaGreen = palette.extended.darkSeaGreen;

/** @deprecated Use `palette.extended.tangerineError` from `theme/tokens/colors` */
export const tangerineError = palette.extended.tangerineError;

/** @deprecated Use `palette.extended.darkGoldenrod` from `theme/tokens/colors` */
export const darkGoldenrod = palette.extended.darkGoldenrod;

/** @deprecated Use `palette.semantic.info.main` from `theme/tokens/colors` */
export const infoColor = palette.semantic.info.main;

/** @deprecated Use `palette.semantic.error.main` from `theme/tokens/colors` */
export const errorColor = palette.semantic.error.main;

/** @deprecated Use `palette.extended.darkteal` from `theme/tokens/colors` */
export const darkteal = palette.extended.darkteal;

/** @deprecated Use `palette.extended.lightred` from `theme/tokens/colors` */
export const lightred = palette.extended.lightred;

/** @deprecated Use `palette.extended.blue` from `theme/tokens/colors` */
export const blue = palette.extended.blue;

/** @deprecated Use `palette.extended.yellow` from `theme/tokens/colors` */
export const yellow = palette.extended.yellow;

/** @deprecated Use `palette.extended.darkgray` from `theme/tokens/colors` */
export const darkgray = palette.extended.darkgray;

/** @deprecated Use `palette.extended.lightpurple` from `theme/tokens/colors` */
export const lightpurple = palette.extended.lightpurple;

/** @deprecated Use `palette.extended.purplePzazz` from `theme/tokens/colors` */
export const purplePzazz = palette.extended.purplePzazz;

/** @deprecated Use `palette.extended.purpleTransparent` from `theme/tokens/colors` */
export const purpleTransparent = palette.extended.purpleTransparent;

/** @deprecated Use `palette.extended.lightblue` from `theme/tokens/colors` */
export const lightblue = palette.extended.lightblue;

/** @deprecated Use `palette.extended.lightgray` from `theme/tokens/colors` */
export const lightgray = palette.extended.lightgray;

/** @deprecated Use `predefinedColors` from `theme/tokens/colors` */
export const predefinedColors = [...tokenPredefinedColors];

/** @deprecated Use `palette.extended.orange` from `theme/tokens/colors` */
export const orange = palette.extended.orange;

/** @deprecated Use `palette.extended.teal` from `theme/tokens/colors` */
export const teal = palette.extended.teal;

/** @deprecated Use `palette.extended.tealLight` from `theme/tokens/colors` */
export const tealLight = palette.extended.tealLight;

/** @deprecated Use `palette.extended.bluegray` from `theme/tokens/colors` */
export const bluegray = palette.extended.bluegray;

/** @deprecated Use `palette.extended.lightbluegray` from `theme/tokens/colors` */
export const lightbluegray = palette.extended.lightbluegray;

/** @deprecated Use `palette.extended.black` from `theme/tokens/colors` */
export const black = palette.extended.black;

/** @deprecated Use `palette.semantic.error.main` from `theme/tokens/colors` */
export const red = palette.semantic.error.main;

/** @deprecated Use `palette.extended.deepblue` from `theme/tokens/colors` */
export const deepblue = palette.extended.deepblue;

/** @deprecated Use `palette.background.subdued` from `theme/tokens/colors` */
export const Background = palette.background.subdued;

/** @deprecated Use `palette.semantic.error.main` from `theme/tokens/colors` */
export const Red = palette.semantic.error.main;

/** @deprecated Use `palette.extended.greyLight` from `theme/tokens/colors` */
export const GreyLight = palette.extended.greyLight;

/** @deprecated Use `palette.extended.greyMediumLight` from `theme/tokens/colors` */
export const GreyMediumLight = palette.extended.greyMediumLight;

/** @deprecated Use `palette.extended.greyMedium` from `theme/tokens/colors` */
export const GreyMedium = palette.extended.greyMedium;

/** @deprecated Use `palette.neutral[800]` from `theme/tokens/colors` */
export const GreyDark = palette.neutral[800];

/** @deprecated Use `palette.extended.greyBorder` from `theme/tokens/colors` */
export const GreyBorder = palette.extended.greyBorder;

/** @deprecated Use `palette.text.primary` from `theme/tokens/colors` */
export const Black = palette.text.primary;

/** @deprecated Use `palette.extended.offWhite` from `theme/tokens/colors` */
export const OffWhite = palette.extended.offWhite;

/** @deprecated Use `palette.extended.offWhiteLight` from `theme/tokens/colors` */
export const OffWhiteLight = palette.extended.offWhiteLight;

/** @deprecated Use `palette.extended.whiteSmoke` from `theme/tokens/colors` */
export const WhiteSmoke = palette.extended.whiteSmoke;

/** @deprecated Use `palette.extended.blueChalk` from `theme/tokens/colors` */
export const BlueChalk = palette.extended.blueChalk;

/** @deprecated Use `palette.background.paper` from `theme/tokens/colors` */
export const White = palette.background.paper;

/** @deprecated Use `palette.extended.green` from `theme/tokens/colors` */
export const Green = palette.extended.green;

/** @deprecated Use `palette.extended.greenDark` from `theme/tokens/colors` */
export const GreenDark = palette.extended.greenDark;

/** @deprecated Use `palette.extended.greyState` from `theme/tokens/colors` */
export const GreyState = palette.extended.greyState;

/** @deprecated Use `palette.extended.burntOrange` from `theme/tokens/colors` */
export const BurntOrange = palette.extended.burntOrange;

/** @deprecated Use `palette.extended.lightPeachBrand` from `theme/tokens/colors` */
export const LightPeachBrand = palette.extended.lightPeachBrand;

/** @deprecated Use `palette.extended.midnightBlue` from `theme/tokens/colors` */
export const MidnightBlue = palette.extended.midnightBlue;

/** @deprecated Use `palette.extended.lightBeige` from `theme/tokens/colors` */
export const LightBeige = palette.extended.lightBeige;

/** @deprecated Use `palette.extended.brandOrangeBrown` from `theme/tokens/colors` */
export const BrandOrangeBrown = palette.extended.brandOrangeBrown;

/** @deprecated Use `palette.extended.palePink` from `theme/tokens/colors` */
export const PalePink = palette.extended.palePink;

/** @deprecated Use `palette.extended.yellowSecondary` from `theme/tokens/colors` */
export const YellowSecondary = palette.extended.yellowSecondary;

/** @deprecated Use `palette.brand.secondary.main` from `theme/tokens/colors` */
export const Yellow = palette.brand.secondary.main;

/** @deprecated Use `palette.brand.primary.light` from `theme/tokens/colors` */
export const PrimaryTint = palette.brand.primary.light;

/** @deprecated Use `palette.extended.tealMuted` from `theme/tokens/colors` */
export const Teal = palette.extended.tealMuted;

/** @deprecated Use `palette.extended.darkTeal` from `theme/tokens/colors` */
export const DarkTeal = palette.extended.darkTeal;

/** @deprecated Use `palette.extended.mediumTeal` from `theme/tokens/colors` */
export const MediumTeal = palette.extended.mediumTeal;

/** @deprecated Use `palette.extended.tealLightLegacy` from `theme/tokens/colors` */
export const TealLight = palette.extended.tealLightLegacy;

/** @deprecated Use `palette.extended.tealLight2` from `theme/tokens/colors` */
export const TealLight2 = palette.extended.tealLight2;

/** @deprecated Use `palette.extended.primaryTeal10` from `theme/tokens/colors` */
export const Teal10 = palette.extended.primaryTeal10;

/** @deprecated Use `palette.extended.silver` from `theme/tokens/colors` */
export const Silver = palette.extended.silver;

/** @deprecated Use `palette.semantic.info.main` from `theme/tokens/colors` */
export const InfoColor = palette.semantic.info.main;

/** @deprecated Use `palette.semantic.success.main` from `theme/tokens/colors` */
export const SuccessColor = palette.semantic.success.main;

/** @deprecated Use `palette.semantic.error.main` from `theme/tokens/colors` */
export const ErrorColor = palette.semantic.error.main;

/** @deprecated Use `palette.extended.fordGray` from `theme/tokens/colors` */
export const FordGray = palette.extended.fordGray;

/** @deprecated Use `palette.extended.steelBlue` from `theme/tokens/colors` */
export const steelBlue = palette.extended.steelBlue;

/** @deprecated Use `palette.extended.brownishGrey` from `theme/tokens/colors` */
export const brownishGrey = palette.extended.brownishGrey;

/** @deprecated Use `palette.extended.whiteCoffee` from `theme/tokens/colors` */
export const whiteCoffee = palette.extended.whiteCoffee;

/** @deprecated Use `palette.extended.brightOrange` from `theme/tokens/colors` */
export const BrightOrange = palette.extended.brightOrange;

/** @deprecated Use `palette.extended.paleYellowOrange` from `theme/tokens/colors` */
export const PaleYellowOrange = palette.extended.paleYellowOrange;

/** @deprecated Use `palette.overlay.light` from `theme/tokens/colors` */
export const PaleGray = palette.overlay.light;

/** @deprecated Use `palette.extended.mustard` from `theme/tokens/colors` */
export const Mustard = palette.extended.mustard;

/** @deprecated Use `palette.extended.mustardDark` from `theme/tokens/colors` */
export const MustardDark = palette.extended.mustardDark;

/** @deprecated Use `palette.extended.mustard80` from `theme/tokens/colors` */
export const Mustard80 = palette.extended.mustard80;

/** @deprecated Use `palette.extended.mustard90` from `theme/tokens/colors` */
export const Mustard90 = palette.extended.mustard90;

/** @deprecated Use `palette.semantic.success.dark` from `theme/tokens/colors` */
export const Euclayptus = palette.semantic.success.dark;

/** @deprecated Use `palette.semantic.success.light` from `theme/tokens/colors` */
export const Euclayptus80 = palette.semantic.success.light;

/** @deprecated Use `palette.extended.veryLightGray` from `theme/tokens/colors` */
export const VeryLightGray = palette.extended.veryLightGray;

/** @deprecated Use `palette.extended.rust` from `theme/tokens/colors` */
export const Rust = palette.extended.rust;

/** @deprecated Use `palette.extended.butter` from `theme/tokens/colors` */
export const Butter = palette.extended.butter;

/** @deprecated Use `palette.extended.russetBrown` from `theme/tokens/colors` */
export const RussetBrown = palette.extended.russetBrown;

/** @deprecated Use `palette.extended.gray900` from `theme/tokens/colors` */
export const Gray900 = palette.extended.gray900;

/** @deprecated Use `palette.extended.gray600` from `theme/tokens/colors` */
export const Gray600 = palette.extended.gray600;

/** @deprecated Use `palette.divider` from `theme/tokens/colors` */
export const LightGrayBorder = palette.divider;

/** @deprecated Use `palette.overlay.dark` from `theme/tokens/colors` */
export const darkGraySemiTransparent = palette.overlay.dark;

/** @deprecated Use `palette.status.done.bg` from `theme/tokens/colors` */
export const DONEColor = palette.status.done.bg;

/** @deprecated Use `palette.status.done.text` from `theme/tokens/colors` */
export const DONETextColor = palette.status.done.text;

/** @deprecated Use `palette.status.pending.text` from `theme/tokens/colors` */
export const PENDINGTextColor = palette.status.pending.text;

/** @deprecated Use `palette.status.pending.bg` from `theme/tokens/colors` */
export const PENDINGColor = palette.status.pending.bg;

/** @deprecated Use `palette.status.warning.bg` from `theme/tokens/colors` */
export const WARNINGColor = palette.status.warning.bg;

/** @deprecated Use `palette.status.warning.text` from `theme/tokens/colors` */
export const WARNINGTextColor = palette.status.warning.text;

/** @deprecated Use `palette.extended.warningText2` from `theme/tokens/colors` */
export const WARNINGTextColor2 = palette.extended.warningText2;

/** @deprecated Use `palette.extended.warningText3` from `theme/tokens/colors` */
export const WARNINGTextColor3 = palette.extended.warningText3;

/** @deprecated Use `palette.extended.warningColorSubdued` from `theme/tokens/colors` */
export const WARNINGColorSubdued = palette.extended.warningColorSubdued;

/** @deprecated Use `palette.status.failed.bg` from `theme/tokens/colors` */
export const FAILEDColor = palette.status.failed.bg;

/** @deprecated Use `palette.status.failed.text` from `theme/tokens/colors` */
export const FAILEDTextColor = palette.status.failed.text;

/** @deprecated Use `palette.status.inProgress.bg` from `theme/tokens/colors` */
export const INPROGRESSColor = palette.status.inProgress.bg;

/** @deprecated Use `palette.status.inProgress.text` from `theme/tokens/colors` */
export const INPROGRESSTextColor = palette.status.inProgress.text;

/** @deprecated Use `palette.extended.strokeLowEmphasis` from `theme/tokens/colors` */
export const StrokeLowEnphasis = palette.extended.strokeLowEmphasis;

/** @deprecated Use `palette.status.draft.bg` from `theme/tokens/colors` */
export const draft = palette.status.draft.bg;

/** @deprecated Use `palette.status.draft.text` from `theme/tokens/colors` */
export const draftText = palette.status.draft.text;

/** @deprecated Use `palette.status.waiting.bg` from `theme/tokens/colors` */
export const waiting = palette.status.waiting.bg;

/** @deprecated Use `palette.status.waiting.text` from `theme/tokens/colors` */
export const waitingText = palette.status.waiting.text;

/** @deprecated Use `palette.status.confirmed.bg` from `theme/tokens/colors` */
export const confirmed = palette.status.confirmed.bg;

/** @deprecated Use `palette.status.confirmed.text` from `theme/tokens/colors` */
export const confirmedText = palette.status.confirmed.text;

/** @deprecated Use `palette.status.delivery.bg` from `theme/tokens/colors` */
export const delivery = palette.status.delivery.bg;

/** @deprecated Use `palette.status.delivery.text` from `theme/tokens/colors` */
export const deliveryText = palette.status.delivery.text;

/** @deprecated Use `palette.status.cancelled.bg` from `theme/tokens/colors` */
export const cancelled = palette.status.cancelled.bg;

/** @deprecated Use `palette.status.cancelled.text` from `theme/tokens/colors` */
export const cancelledText = palette.status.cancelled.text;

/** @deprecated Use `palette.extended.cancelledHoverText` from `theme/tokens/colors` */
export const cancelledHoverText = palette.extended.cancelledHoverText;

/** @deprecated Use `palette.status.delivered.bg` from `theme/tokens/colors` */
export const delivered = palette.status.delivered.bg;

/** @deprecated Use `palette.status.delivered.text` from `theme/tokens/colors` */
export const deliveredText = palette.status.delivered.text;

/** @deprecated Use `palette.extended.matchingRoute` from `theme/tokens/colors` */
export const MatchingRoute = palette.extended.matchingRoute;

/** @deprecated Use `palette.brand.primary.main` from `theme/tokens/colors` */
export const PrimaryTeal = palette.brand.primary.main;

/** @deprecated Use `palette.extended.primaryTealLight` from `theme/tokens/colors` */
export const PrimaryTealLight = palette.extended.primaryTealLight;

/** @deprecated Use `palette.extended.alertOrange` from `theme/tokens/colors` */
export const AlertOrange = palette.extended.alertOrange;

/** @deprecated Use `palette.extended.lightBackground` from `theme/tokens/colors` */
export const LightBackground = palette.extended.lightBackground;

/** @deprecated Use `palette.extended.pineGreen` from `theme/tokens/colors` */
export const PineGreen = palette.extended.pineGreen;

/** @deprecated Use `palette.extended.pineGreenLight` from `theme/tokens/colors` */
export const PineGreenLight = palette.extended.pineGreenLight;

/** @deprecated Use `palette.extended.fireEngineRed` from `theme/tokens/colors` */
export const fireEngineRed = palette.extended.fireEngineRed;

/** @deprecated Use `palette.extended.fireEngineRedLight` from `theme/tokens/colors` */
export const fireEngineRedLight = palette.extended.fireEngineRedLight;

/** @deprecated Use `palette.extended.fireEngineRedLighter` from `theme/tokens/colors` */
export const fireEngineRedLighter = palette.extended.fireEngineRedLighter;

/** @deprecated Use `palette.extended.fireEngineRedDark` from `theme/tokens/colors` */
export const fireEngineRedDark = palette.extended.fireEngineRedDark;

/** @deprecated Use `palette.extended.vibrantOrange` from `theme/tokens/colors` */
export const vibrantOrange = palette.extended.vibrantOrange;

/** @deprecated Use `palette.extended.saffronYellow` from `theme/tokens/colors` */
export const saffronYellow = palette.extended.saffronYellow;

/** @deprecated Use `palette.extended.royalBlue` from `theme/tokens/colors` */
export const royalBlue = palette.extended.royalBlue;

/** @deprecated Use `palette.extended.jungleGreen` from `theme/tokens/colors` */
export const jungleGreen = palette.extended.jungleGreen;

/** @deprecated Use `palette.extended.mintGreen` from `theme/tokens/colors` */
export const mintGreen = palette.extended.mintGreen;

/** @deprecated Use `palette.extended.lavenderBlue` from `theme/tokens/colors` */
export const lavenderBlue = palette.extended.lavenderBlue;

/** @deprecated Use `palette.extended.blue700` from `theme/tokens/colors` */
export const blue700 = palette.extended.blue700;

/** @deprecated Use `palette.extended.champagne` from `theme/tokens/colors` */
export const champagne = palette.extended.champagne;

/** @deprecated Use `palette.extended.mustardYellow` from `theme/tokens/colors` */
export const mustardYellow = palette.extended.mustardYellow;

/** @deprecated Use `palette.extended.amber600` from `theme/tokens/colors` */
export const amber600 = palette.extended.amber600;

/** @deprecated Use `palette.extended.primaryStatusBg` from `theme/tokens/colors` */
export const PRIMARY_STATUS_BG_COLOR = palette.extended.primaryStatusBg;

/** @deprecated Use `palette.extended.primaryDefaultTxt` from `theme/tokens/colors` */
export const PRIMARY_DEFAULT_TXT_COLOR = palette.extended.primaryDefaultTxt;

/** @deprecated Use `palette.banner.warning.bg` from `theme/tokens/colors` */
export const warningBannerBg = palette.banner.warning.bg;

/** @deprecated Use `palette.banner.warning.text` from `theme/tokens/colors` */
export const warningBannerText = palette.banner.warning.text;

/** @deprecated Use `palette.banner.warning.button` from `theme/tokens/colors` */
export const warningBannerButton = palette.banner.warning.button;

/** @deprecated Use `palette.banner.warning.buttonHover` from `theme/tokens/colors` */
export const warningBannerButtonHover = palette.banner.warning.buttonHover;

/** @deprecated Use `palette.banner.info.bg` from `theme/tokens/colors` */
export const infoBannerBg = palette.banner.info.bg;

/** @deprecated Use `palette.banner.info.text` from `theme/tokens/colors` */
export const infoBannerText = palette.banner.info.text;

/** @deprecated Use `palette.banner.info.button` from `theme/tokens/colors` */
export const infoBannerButton = palette.banner.info.button;

/** @deprecated Use `palette.banner.info.buttonHover` from `theme/tokens/colors` */
export const infoBannerButtonHover = palette.banner.info.buttonHover;
